<template>
  <v-card class="elevation-3">
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs4 lg2 class="center_middle d-flex">
          <v-avatar
            :size="80"
            >
            <profile-image class="img-cst" :src="$store.getters.getUserProfileImage(item.employee.job.profileImage)" />
          </v-avatar>
        </v-flex>
        <v-flex xs8 lg10>
          <v-card-text>
            <strong>{{item.employee.name}} ({{item.employee.nik}})</strong><br />
            {{item.employee.job.jobProfileName}} | {{item.employee.job.divisionDept}}<br />
            {{item.fromDate|moment('DD MMM YYYY')}} - {{item.toDate|moment('DD MMM YYYY')}} | {{item.costType}} <br><b> {{totalExpense | numformat('Rp. ', 0)}}</b>
          </v-card-text>
        </v-flex>
      </v-layout>
      <v-flex xs12 lg12 class="pa-0">
          <v-layout row wrap>
            <v-flex xs4 class="pt-0">
              <v-btn flat class="mx-auto" block @click.native="expense"><v-icon>attach_money</v-icon> Expense</v-btn>
            </v-flex>
            <v-flex xs4 class="pt-0">
              <v-btn flat class="mx-auto" block @click.native="edit"><v-icon>edit</v-icon> Detail</v-btn>
            </v-flex>
            <v-flex xs4 class="pt-0">
              <v-btn flat class="mx-auto" block @click.native="_delete" :disabled="!editable"><v-icon>delete</v-icon> Delete</v-btn>
            </v-flex>
          </v-layout>
      </v-flex>
      <steppercst v-if="this.track">
        <div class="step-item-cont">
          <div class="step-item mb-2" :class="getdocstateColor(this.track.reqstatus)">
            1
          </div>
          <span>
          {{this.track?this.track.reqstatus:''}}<br>
          {{this.track?this.track.reqbatchno:''}}<br>
          <span class="stepitem-date">{{this.track?this.track.reqtime:'' | moment('DD MMM YYYY hh:mm:ss')}}</span>
          </span>
        </div>
        <v-divider/>
        <div class="step-item-cont">
          <div class="step-item mb-2" :class="getFundColor(this.track.fundstatus)">
            2
          </div>
          <span v-if="this.track && this.track.fundstatus !== '-'">
          {{this.track.fundstatus}}<br>
          {{this.track.fundtotal | numformat('Rp.',0)}} ({{this.track.rate?this.track.rate:0}}%)<br>
          <span class="stepitem-date">{{this.track.funddate | moment('DD MMM YYYY hh:mm:ss')}}</span>
          </span>
          <span v-else class="stepitem-date">
            Funds
          </span>
        </div>
        <v-divider/>
        <div class="step-item-cont">
          <div class="step-item mb-2" :class="getdocstateColor(this.track.realstatus)">
            3
          </div>
          <span v-if="this.track && this.track.realstatus">
          {{this.track.realstatus}}<br>
          <span @click="routeTo()" style="color: blue; cursor:pointer;border-bottom: 1px dotted #000;">{{this.track.realbatchno}}<br></span>
          <span class="stepitem-date">{{this.track.realtime | moment('DD MMM YYYY hh:mm:ss')}}</span>
          </span>
          <span v-else class="stepitem-date">
            Realisasi
          </span>
        </div>
      </steppercst>
    </v-container>
  </v-card>
</template>

<script>
import Vuex from 'vuex'
import ProfileImage from '@/components/ProfileImage'
import steppercst from '@/components/business-trip/steppercst'

const btRequestEmployeesStore = Vuex.createNamespacedHelpers('BusinessTripRequest/Employees')

export default {
  name: 'employee-card',
  components: {
    ProfileImage,
    steppercst
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      item: {employee: {job: {}}},
      track: null
    }
  },
  computed: {
    totalExpense () {
      if (typeof this.item.expenses !== 'undefined') {
        return this.item.expenses.map(x => parseInt(x.subTotal)).reduce((x, y) => x + y, 0)
      } else {
        return 0
      }
    }
  },
  watch: {
    value: function (newValue) {
      this.item = newValue
    }
  },
  methods: {
    ...btRequestEmployeesStore.mapActions({
      getEmpTracking: 'getEmpTracking'
    }),
    routeTo () {
      this.$router.push({name: 'business-trip-realization-detail',
        params: {
          id: this.track.realid,
          backRoute: {
            name: 'business-trip-realization-list'
          }
        }})
    },
    loadData () {
      this.item = this.value
      this.getEmpTracking({vueinstance: this, id: this.item.sppd.id, empid: this.item.id}).then(res => {
        if (res.length > 0) this.track = res[0]
      })
    },
    getdocstateColor (val) {
      return !val ? 'grey lighten-3 grey--text' : val === 'DRAFTED' ? 'grey darken-4' : val === 'SUBMITTED' ? 'success' : val === 'APPROVED' ? 'primary' : val === 'REJECTED' ? 'error' : val === 'REVISION' ? 'yellow accent-4' : 'orange'
    },
    getFundColor (val) {
      return val === '-' ? 'grey lighten-3 grey--text' : 'primary'
    },
    edit () {
      this.$emit('edit', this.item)
    },
    _delete () {
      this.$emit('delete', this.item)
    },
    expense () {
      this.$emit('expense', this.item)
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>
<style scoped>
@media only screen and (max-width: 599px) {
  .mx-auto{
    font-size: 12px;
  }
}
.center_middle{
  align-items: center !important;
}
.img-cst{
  border: 1px solid rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/business-trip/EmployeeCard.vue